<div class="main-container">
  <div class="image-section">
    <img src="assets/icons/playground-nodata.svg" alt="no-data">
  </div>
  <div class="info-section">
    <div class="info-title">
      Ready to test your taxonomies?
    </div>
    <div class="info-subtitle">
      Please run a test by clicking on New Test button to see results
    </div>
  </div>
</div>
